module.exports = __webpack_public_path__ + "static/img/098_TO8_1778.712ea03.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/098_TO8_1778.jpg
// module id = 30lI
// module chunks = 0